import PortsMain from "../modules/portsModule/views/Main.vue";
import Dashboard from "../modules/portsModule/views/Dashboard.vue";
import IncomingShipments from "../modules/portsModule/views/IncomingShipments.vue";
import DockedShipments from "../modules/portsModule/views/DockedShipments.vue";
import PortHistory from "../modules/portsModule/views/PortHistory.vue";
import ExpectedDepartures from "../modules/portsModule/views/ExpectedDepartures.vue";
import ShippingDetails from "../modules/portsModule/views/ShippingDetails.vue";
import CompletedShipments from "../modules/portsModule/views/CompletedShipments.vue";
import UpdateModal from "../modules/portsModule/components/UpdateModal.vue";
import PortGuide from "../modules/portsModule/views/PortGuide.vue";
import Profile from "../modules/portsModule/views/Profile.vue";

export default [
  {
    path: "/port",
    name: "ports-main-view",
    component: PortsMain,
    children: [
      {
        path: "/port/dashboard",
        name: "port-dashboard",
        component: Dashboard,
        meta: { requiresAuth: true }
      },
      {
        path: "/port/port-history",
        name: "port-activities-history",
        component: PortHistory,
        meta: { requiresAuth: true }
      },
      {
        path: "/port/incoming-shipments",
        name: "incoming-shipments",
        component: IncomingShipments,
        meta: { requiresAuth: true }
      },
      {
        path: "/port/berth-shipments",
        name: "berth-shipments",
        component: DockedShipments,
        meta: { requiresAuth: true }
      },
      {
        path: "/port/expected-departures",
        name: "expected-departures",
        component: ExpectedDepartures,
        meta: { requiresAuth: true }
      },
      {
        path: "/port/completed-shipments",
        name: "completed-shipments",
        component: CompletedShipments,
        meta: { requiresAuth: true }
      },
      {
        path: "/port/shipper-details/:id",
        name: "port-shipper-details",
        component: ShippingDetails,
        props: true,
        meta: { requiresAuth: true }
      },

      {
        path: "/port/update-shipment-status/:id",
        name: "update-shipment-status",
        component: UpdateModal,
        props: true,
        meta: { requiresAuth: true }
      },

      {
        path: "/port/profile-settings",
        name: "port-profile-settings",
        component: Profile,
        meta: { requiresAuth: true }
      },

      {
        path: "/port/port-guide",
        name: "port-guide",
        component: PortGuide,
        meta: { requiresAuth: true }
      }
    ]
  }
];
